import React from 'react';
import PropTypes from 'prop-types';

import './BrochurePage.scss';
import '../Skeleton/Skeleton.scss';

const BrochurePageSkeleton = ({ className }) => (
  <div className={className}>
    {/* Header skeleton */}
    <div className="pibPage-branding" style={{ display: 'flex', justifyContent: 'center' }}>
      <div className="pibPage-branding__logoLink">
        <div className="skeleton skeleton--basic" style={{ width: '200px', height: '80px' }} />
      </div>
    </div>

    <div className="pibPage-welcome skeleton-replaceBg">
      <div className="pibPage-welcome__intro">
        <div className="skeleton skeleton--basic skeleton--full" />
      </div>
      <div className="pibPage-welcome__contact">
        <div className="skeleton skeleton--basic skeleton--full" />
      </div>
      <div className="pibPage-welcome__date" style={{ textAlign: 'center' }}>
        <div className="skeleton skeleton--basic skeleton--medium" style={{ margin: '0 auto' }} />
      </div>
    </div>

    {/* Pane buttons skeleton */}
    <div className="pibPage-favorites">
      <div className="panesWidget">
        <div className="paneButtons">
          <div className="paneButton skeleton skeleton--basic" />
          <div className="paneButton skeleton skeleton--basic" />
          <div className="paneButton skeleton skeleton--basic" />
        </div>

        <div className="panesWidget-frame">
          <div className="subpane">
            <div className="skeleton skeleton--full" style={{ minHeight: '80vh', borderRadius: '8px' }} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

BrochurePageSkeleton.propTypes = {
  className: PropTypes.string,
};

BrochurePageSkeleton.defaultProps = {
  className: '',
};

export default BrochurePageSkeleton;
